import React, { useEffect, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ExternalLink } from 'lucide-react';
import { useApply } from './ApplyContext';
const FORM_URL = 'https://forms.gle/ocVsPaXBDBsiysi77';
export const ApplyModal = () => {
  const {
    isOpen,
    close
  } = useApply();
  // Lock body scroll while open + close on Escape
  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener('keydown', onKey);
    };
  }, [isOpen, close]);
  return <AnimatePresence data-id="element-20">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.25
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6 bg-navy/80 backdrop-blur-sm" onClick={close} role="dialog" aria-modal="true" aria-label="Application form" data-id="element-21">
          <motion.div initial={{
        scale: 0.95,
        y: 20,
        opacity: 0
      }} animate={{
        scale: 1,
        y: 0,
        opacity: 1
      }} exit={{
        scale: 0.95,
        y: 20,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} onClick={e => e.stopPropagation()} className="relative w-full max-w-3xl h-[90vh] bg-ivory rounded-md shadow-2xl ring-1 ring-gold/30 overflow-hidden flex flex-col" data-id="element-22">
            {/* Header */}
            <div className="flex items-center justify-between px-5 py-3 bg-navy text-ivory border-b border-gold/20" data-id="element-23">
              <div className="flex items-center gap-3" data-id="element-24">
                <span className="font-serif text-lg" data-id="element-25">
                  Apply to the Fellowship
                </span>
                <span className="hidden sm:inline-block text-xs font-sans text-parchment/60 tracking-wider uppercase" data-id="element-26">
                  · Inaugural Cohort
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-27">
                <a href={FORM_URL} target="_blank" rel="noopener noreferrer" className="hidden sm:inline-flex items-center gap-1.5 text-xs font-sans text-ivory/80 hover:text-kesari transition-colors px-2 py-1" aria-label="Open form in new tab" data-id="element-28">
                  Open in new tab
                  <ExternalLink size={12} data-id="element-29" />
                </a>
                <button onClick={close} className="text-ivory/70 hover:text-kesari transition-colors p-1 rounded-sm hover:bg-ivory/10" aria-label="Close application" data-id="element-30">
                  <X size={20} data-id="element-31" />
                </button>
              </div>
            </div>

            {/* Iframe */}
            <iframe src={FORM_URL} title="Civic Leadership Fellowship Application" className="flex-1 w-full border-0 bg-ivory" loading="lazy" data-id="element-32">
              Loading…
            </iframe>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
};